/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import Searchbar from "../../../Helpers/Searchbar/Searchbar";
import ObjectUsers from "../ObjectUsers/ObjectUsers";
import { popupcontext } from "../../../../context/Popupscontext";
import Button from "../../../Helpers/Button/Button";
import { filtrationcontext } from "../../../../context/Filtercontext";
import { useLocation } from "react-router-dom";
import trans from "../../../../utils";

export default function ObjectSearch() {
  const { display, handleShow, setDisplay } = useContext(popupcontext);
  const { setObjectSearchQuery, setSearchQuery } =
    useContext(filtrationcontext);
  const [query, setQuery] = useState("");
  let { pathname } = useLocation();
  useEffect(() => {
    return () => {
      setQuery(null);
      setObjectSearchQuery(null);
      setDisplay(false);
    };
  }, [pathname, setObjectSearchQuery, setDisplay]);
  useEffect(() => {
    return () => {
      setDisplay(false);
    };
  }, [setDisplay]);

  const handleSearch = (e) => {
    if (pathname === "/livetracking") {
      setQuery(e.target.value);
      setObjectSearchQuery(e.target.value);
    } else {
      setQuery(e.target.value);
      setSearchQuery(e.target.value);
    }
  };
  return (
    <>
      <div className="d-flex align-items-center p-8 my-8 gap-8">
        <div className="object-search w-100">
          <Searchbar
            style="search-dark input-group"
            path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
            placeholder={trans("Search")}
            value={query}
            onChange={handleSearch}
            width={320}
          />
        </div>

        {pathname === "/livetracking" && (
          <Button
            text={trans("Groups")}
            type="default"
            htmlType="button"
            onClick={() => {
              handleShow("objectUsers");
            }}
          />
        )}
      </div>
      {display && <ObjectUsers />}
    </>
  );
}
